$ = jQuery;
import { closeMenus } from "./headerMenu";

const CSS_SHOWING = "Site--quickSearchShowing";
const CSS_VISIBLE = "Site--quickSearchVisible";

function getSite() {
  return $(".js-site").eq(0);
}

function showQuickSearch() {
  closeMenus();
  const $site = getSite();
  window.requestAnimationFrame(() => {
    $site.addClass(CSS_SHOWING);

    window.requestAnimationFrame(() => {
      $site.addClass(CSS_VISIBLE);
      $(".js-quicksearch-input").focus();
    });
  });
}

export function hideQuickSearch() {
  const $site = getSite();
  $site.removeClass(CSS_VISIBLE);

  window.setTimeout(() => {
    $site.removeClass(CSS_SHOWING);
  }, 500);
}

function toggleQuickSearch() {
  const $site = getSite();

  if ($site.hasClass(CSS_SHOWING)) {
    hideQuickSearch();
  } else {
    showQuickSearch();
  }
}

function setupTogglers() {
  const $togglers = $(".js-quicksearch-toggle");
  $togglers.click(toggleQuickSearch);
}

function setupClosers() {
  const $closers = $(".js-quicksearch-hide");
  $closers.click(hideQuickSearch);
}

function setup() {
  setupTogglers();
  setupClosers();
}

export default function() {
  $(setup);
}
